
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const PremiumButton = () => {
  const { isSubscribed } = useAuth();

  if (isSubscribed) {
    return (
      <Button 
        variant="outline" 
        size="sm"
        className="bg-primary/10 text-primary border-primary/20 cursor-default"
        disabled
      >
        <Check className="h-4 w-4 mr-1" />
        Premium Access
      </Button>
    );
  }

  return (
    <Link to="/get-premium">
      <Button size="sm">
        Get Premium
      </Button>
    </Link>
  );
};

export default PremiumButton;
